// @flow

export { default } from './Pagination';
